import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { WidgetComponent } from '../widget/widget.component';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { PrimaryButtonComponent } from '../../shared/buttons/primary-button.component';

@Component({
  selector: 'sibat-control-dashboard-widget',
  templateUrl: './control-dashboard-widget.component.html',
  styleUrls: ['./control-dashboard-widget.component.scss'],
  imports: [WidgetComponent, MatIcon, TranslocoDirective, PrimaryButtonComponent, TranslocoPipe],
})
export class ControlDashboardWidgetComponent {
  constructor(public router: Router) {}

  goToControlDashboard(): void {
    this.router.navigate(['/cockpit/control-dashboard']);
  }
}
